import { Component, Input } from '@angular/core';
import { FontIconType } from '../../../types/common.types';

@Component({
  selector: 'idp-font-icon',
  templateUrl: './font-icon.component.html',
  styleUrls: ['./font-icon.component.scss']
})
export class FontIconComponent {
  @Input() iconImage = '' as string;
  @Input() iconType: FontIconType = 'info';
}
